import { render, staticRenderFns } from "./TrainingsSuccessModal.vue?vue&type=template&id=b60dad02&scoped=true"
import script from "./TrainingsSuccessModal.vue?vue&type=script&lang=js"
export * from "./TrainingsSuccessModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingsSuccessModal.vue?vue&type=style&index=0&id=b60dad02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60dad02",
  null
  
)

export default component.exports